<template>
  <div class="succDiv">
    <div class="approvedDiv">
      <div class="approved" id="approvedId">
        <div class="iconDiv">
          <img
            src="../assets/image/btn_weitongguo_nor.png"
            alt="失败"
            class="icon"
          />
        </div>
        <div class="succ">请先注册核销人员!</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.approvedDiv {
  position: relative;
  width: 100%;
  left: 5%;
  .approved {
    position: relative;
    margin-top: 20px;
    width: 90%;
    height: 70vh;
    background-image: url(../assets/image/btn_yuyuechenggong_nor.png);
    background-size: 100%, 100%;
    background-repeat: no-repeat, no-repeat;
    .iconDiv {
      position: absolute;
      top: 25%;
      left: 50%;
      transform: translateX(-50%);
      width: 20%;
      .icon {
        width: 100%;
      }
    }
    .succ {
      position: absolute;
      top: 42%;
      left: 50%;
      transform: translateX(-50%);
      font-size: 1.3rem;
      font-weight: bold;
      color: #333333;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/WriteOffNotRegister.vue